var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('form.button.remove')),expression:"$t('form.button.remove')"}],class:['remove', _vm.disabled ? 'text-secondary disabled' : 'text-danger'],on:{"click":_vm.handleDelete}},[_c('i',{staticClass:"fas fa-trash"})])
}
var staticRenderFns = []

export { render, staticRenderFns }